import styles from '../AccessBackOfficePermission.css'
import _ from 'lodash'
import Row from './Row'

class Menu extends React.Component {
  render () {
    let {menu, submenu} = this.props
    let isMenuChecked = this._isAllSubMenuChecked()
    return (
      <div className='col-lg-12'>
        {this._hasSubMenu() && <div className={`checkbox checkbox-primary ${!isMenuChecked && this._hasSubMenuChecked() > 0 ? 'partial-checked' : ''}`}>
          <input
            type='checkbox'
            id={this._removeSpace(menu)}
            checked={isMenuChecked}
            onChange={this._onChangeMenuCheckbox}
            className='partial-checked'
          />
          <label for={this._removeSpace(menu)}>{menu}</label>
        </div>}
        <div className={`${styles['container-subs']} ${submenu.length === 1 && !this._hasSubMenu() ? styles['single-submenu'] : ''}`}>
          {submenu.map((permission) => {
            return (
              <Row
                checked={this._isSubMenuChecked(permission)}
                onChangeCheckbox={this._onChangeSubMenuCheckbox}
                permission={permission}
              />
            )
          })}
        </div>
      </div>
    )
  }

  _hasSubMenu = () => {
    let {menu, submenu} = this.props
    return submenu[0].sub_menu !== menu
  }
  _removeSpace (str) {
    return str.replace(/\s+/g, '')
  }

  _isAllSubMenuChecked = () => {
    const {fields, submenu} = this.props
    const currentValue = fields.getAll()

    for (let i = 0; i < submenu.length; i++) {
      if (!_.find(currentValue, {id: submenu[i].id})) {
        return false
      }
    }

    return true
  }

  _hasSubMenuChecked = () => {
    const {fields, submenu} = this.props
    const currentValue = fields.getAll()

    for (let i = 0; i < submenu.length; i++) {
      if (_.find(currentValue, {id: submenu[i].id})) {
        return true
      }
    }

    return false
  }

  _onChangeMenuCheckbox = (e) => {
    const nextState = !this._hasSubMenuChecked()
    const {fields, submenu} = this.props
    const currentValue = fields.getAll()

    if (nextState) {
      for (let i = 0; i < submenu.length; i++) {
        let permission = submenu[i]
        const index = _.findIndex(currentValue, {'id': permission.id})
        if (index === -1) {
          fields.push(permission)
        }
      }
    } else {
      let listIndex = []
      for (let i = 0; i < submenu.length; i++) {
        let permission = submenu[i]
        const index = _.findIndex(currentValue, {'id': permission.id})
        if (index !== -1) {
          listIndex.push(index)
        }
      }
      // this logic below is necessary, because when one of the obj
      // removed from the array, the index will shift hence we should
      // remove from the largest index first so it wont affect lowest index
      let descendedSortedIndex = listIndex.sort((a, b) => b - a)
      descendedSortedIndex.forEach((index) => {
        fields.remove(index)
      })
    }
  }

  _isSubMenuChecked = (permission) => {
    const {fields} = this.props
    const currentValue = fields.getAll()
    return _.findIndex(currentValue, {'id': permission.id}) !== -1
  }

  _onChangeSubMenuCheckbox = (permission) => {
    const {fields} = this.props
    const currentValue = fields.getAll()
    const index = _.findIndex(currentValue, {'id': permission.id})
    if (index === -1) {
      fields.push(permission)
    } else {
      fields.remove(index)
    }
  }
}

export default Menu



// WEBPACK FOOTER //
// ./app/pages/Employees/Role/RoleDetail/RoleForm/AccessBackOfficePermission/Menu/Menu.js